import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import Login from '../components/Login';
import AppLayout from '../components/AppLayout';
import Home from '../components/Home';
import PageEditor from '../components/PageEditor';
import NotionPageView from '../components/NotionPageView';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Auth routes */}
      <Route path="/login" element={<Login />} />
      
      {/* All routes use AppLayout - it handles auth-based rendering */}
      <Route path="/" element={<AppLayout />}>
        {/* Home page - protected */}
        <Route index element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        } />
        
        {/* Page routes - public for viewing, protected for editing */}
        <Route path="page/:slug" element={<NotionPageView />} />
        <Route path="page/:slug/view" element={<NotionPageView />} />
        <Route path="page/edit/:slug" element={
          <PrivateRoute>
            <PageEditor />
          </PrivateRoute>
        } />
      </Route>
      
      {/* Redirect to home for unknown routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;